export const setTitle = function (title: string): void {
	document.getElementsByTagName("title")[0].innerText = `${ title } - Fangame archive`;
}
